export default function BrandGhostie({ className = '' }) {
  return (
    <span className={className} aria-label="Ghostie">
      G<span className="text-[#f97316]">host</span>ie
    </span>
  );
}
